module.exports = __webpack_public_path__ + "img/wechat.f01f0eef.jpg";